var map = {
	"./images/bitcoin.png": 1801
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1800;


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/media ^.*\/bitcoin\.png$
// module id = 1800
// module chunks = 146